export default __webpack_public_path__ + "static/media/status-succes.09424a79.svg";